import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TitleCard } from '@/core/components';

import { NoOfAuthors, PublishedAtText } from '@/feature/utils';

import { Dictionary } from '../../model/DictionaryTypes';
import classes from './DictionaryCard.module.css';

export interface DictionaryCardProps {
  dictionary: Dictionary;
  to?: string;
  onClick?: () => void;
}

export function DictionaryCard({ dictionary, to, onClick }: DictionaryCardProps) {
  const { t } = useTranslation();
  const { title, publisher, type, publicationYear, authors } = dictionary;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="4px">
        <TitleCard
          title={title}
          pre={
            <Group gap="3px">
              <Pill>{t(`dictionaries.typeEnum.${type}`)}</Pill>
            </Group>
          }
        />
        <Group>{publisher && <Text>{publisher.title}</Text>}</Group>{' '}
        <Group>
          <PublishedAtText
            date={{ year: publicationYear }}
            size="sm"
            c="dimmed"
          />
          <NoOfAuthors authors={authors} />
        </Group>
      </Stack>
    </Paper>
  );
}
